import React from "react";
import { motion } from "framer-motion";
import { FraudEntryType } from "shared/types/types";

type Props = {
  entryType: FraudEntryType;
  setEntryType: (t: FraudEntryType) => void;
  onNext: () => void;
};

export default function FraudStepTypeSelect({ entryType, setEntryType, onNext }: Props) {
  return (
    <div className="step-card">
      <h2>Vérifiez votre annonce</h2>
      <p>Sélectionnez le type d’analyse que vous souhaitez effectuer :</p>

      <div className="choice-grid">
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          className={`choice-card ${entryType === "url" ? "selected" : ""}`}
          onClick={() => setEntryType("url")}
        >
          🔗 <h4>Analyse par lien</h4>
          <p>Collez l’URL de votre annonce (Leboncoin, etc.)</p>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          className={`choice-card ${entryType === "image" ? "selected" : ""}`}
          onClick={() => setEntryType("image")}
        >
          🖼️ <h4>Analyse par image</h4>
          <p>Téléversez une capture de votre annonce</p>
        </motion.div>
      </div>

      <button
        className="wizard-btn primary"
        disabled={!entryType}
        onClick={onNext}
      >
        Suivant →
      </button>
    </div>
  );
}
